import React, { useState, useEffect,useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ImportEmployeesModal from "../../../components/modelpopup/ImportEmployeesModal";
import {Modal } from "antd"; // Modal for triggering the export
import EmployeeListFilter from "../../../components/EmployeeListFilter";
import { Avatar_02 } from "../../../Routes/ImagePath";
import { Avatar_01 } from "../../../Routes/ImagePath";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import axios from "axios"; // Import axios for making HTTP requests

const AllEmployee = () => {
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);
  const navigate = useNavigate(); // Use the useNavigate hook
  const [isModalVisible, setIsModalVisible] = useState(false);



  const handleExport = () => {
    const formattedData = employeeData.map((employee) => ({
      Employee_ID: employee.id,
      Employee_Code: employee.empcode,
      Name: `${employee.name} ${employee.lastname}`,
      Email: employee.email,
      Mobile: employee.mobile,
      Department: employee.department_name,
      Designation: employee.designation_name,
      Gender: employee.gender,
      Status: employee.empstatus === "1" ? "Active" : "Inactive",
      Shift: employee.shift_name,
      Work_Location: employee.work_location,
      Date_of_Joining: employee.employee_doj,
      Date_of_Birth: employee.date_of_birth,
      Reporting_To: employee.reporting_name,
      Tally_Name: employee.tally_name,
      Is_Tally_Synched: employee.is_tally_synch ? "Yes" : "No",
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");
    XLSX.writeFile(workbook, "EmployeeData.xlsx");

    setIsModalVisible(false); // Close the modal after exporting
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);



  useEffect(() => {
    fetchEmployeeData();
  }, [apiUrl, token]);


  const capitalizeFirstChar = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const fetchEmployeeData = () => {
    setLoading(true);
    fetch(`${apiUrl}/employees/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setEmployeeData(data.employees);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
        setLoading(false);
      });
  };

  const handleEmployeeAdded = (newEmployee) => {
    if (newEmployee) {
      setEmployeeData((prevData) => {
        // Ensure we have the full employee object and not just the response
        const employeeToAdd = newEmployee.employee || newEmployee;
        
        // Check if the new employee is already in the list (based on a unique identifier, e.g., id)
        const isExistingEmployee = prevData.some(employee => employee.id === employeeToAdd.id);
  
        if (!isExistingEmployee) {
          // If the employee is new, add them to the list
          return [...prevData, employeeToAdd];
        } else {
          // If the employee already exists, replace the existing employee's data with the new data
          return prevData.map(employee =>
            employee.id === employeeToAdd.id ? employeeToAdd : employee
          );
        }
      });
    }
  };
  
  

  const handleFilterApplied = (filteredData) => {
    setEmployeeData(filteredData);
  };


  const deleteEmployee = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this employee!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${apiUrl}/employees/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setEmployeeData(employeeData.filter((employee) => employee.id !== id));
        await Swal.fire("Deleted!", "Employee has been deleted.", "success");
      } catch (error) {
        let errorMessage = "Failed to delete employee. Please try again later.";
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        await Swal.fire("Error!", errorMessage, "error");
      }
    }
  };



  return (

    <div className="page-wrapper">
      <div className="content container-fluid">
    <div className="page-header page-top-icons">
    <div className="row align-items-center">
      <div className="col-md-4">
      <h3 className="page-title">Employees</h3>
      </div>
      <div className="col-md-8 float-end ms-auto">
        <div className="d-flex title-head">
          <div className="view-icons">
          <Link to="/employees" className="grid-view btn btn-link active mx-2">
              <i className="fa fa-th" />
            </Link>

            <Link to="/employees-list" className="list-view btn btn-link">
              <i className="fa fa-bars" />
            </Link>

            <Link to="#" className="list-view btn btn-link" data-bs-toggle="modal"  data-bs-target="#scrollable-modal">
        <i className="las la-filter" />
      </Link>
            
      <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
              <i className="las la-expand-arrows-alt" />
            </Link>


            <Link
        to="#"
        className="list-view btn btn-link"

        onClick={() => setIsModalVisible(true)} // Show modal
      >
        <i className="las la-file-export" />
      </Link>


              <Link
                to="#"
                className="list-view btn btn-link"
                data-bs-toggle="modal"
                data-bs-target="#import_employees"
              >
                <i className="las la-file-import" />
                
              </Link>
          </div>
          <Link to="#" className="btn add-btn custom-btn" data-bs-toggle="modal" data-bs-target="#add_employee">
          <i className="la la-plus-circle custom-icon" /> Add New
          </Link>
        </div>
      </div>
    </div>
  </div>
     
          
        <EmployeeListFilter onFilterApplied={handleFilterApplied} />
        <div className="row">
          {loading ? (
            <div id="loader-wrapper-">
              <div className="loader">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          ) : employeeData.length === 0 ? (
            <div className="no-data-container">
      <img 
        src="https://netshine-assets.blr1.cdn.digitaloceanspaces.com/app-assets/empty-data.svg" 
        alt="No data available" 
      />
            <h3>No Data Available</h3>
            <p>There are no employees to display right now. Please add new employees.</p>
          </div>
          ) : (
            employeeData.map((employee) => (
              <div
                className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                key={employee.id}
              >
                <div className="profile-widget">
                  <div className="profile-img">
                    <Link to={`/profile/${employee.id}`}>
                                    <img 
                  src={employee.profile_pic 
                        ? `${cdnUrl}/${employee.profile_pic}` 
                        : (employee.gender === 'male' ? Avatar_01 : Avatar_02)
                      }
                  alt="Employee Avatar"
                />
                      </Link>
                  </div>
                  <div className="dropdown profile-action">
                    <Link
                      to="#"
                      className="action-icon dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons">more_vert</i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
      
                      <Link  className="dropdown-item" to={`/profile/${employee.id}`}>
                      <i className="fa fa-pencil m-r-5" /> Edit
                      </Link>

                      <button
                        className="dropdown-item"
                        onClick={() => deleteEmployee(employee.id)}
                      >
                        <i className="fa fa-trash m-r-5" /> Delete
                      </button>
                    </div>
                  </div>
                  <h4 className="user-name m-t-10 mb-0 text-ellipsis">
                    <Link to={`/profile/${employee.id}`}>
                      {capitalizeFirstChar(employee.name)} {capitalizeFirstChar(employee.lastname)}
                    </Link>
                  </h4>
                  <div className="small text-muted small-line-height">
                    {employee.designation_name}
                  </div>
                  <div className="small text-muted small-line-height">
                    {capitalizeFirstChar(employee.gender)}
                  </div>
                  <div className="small text-muted small-line-height">
                    {employee.department_name}
                  </div>
                  <div className="small text-muted small-line-height">{employee.mobile}</div>
                  <div className="small text-muted small-line-height">{employee.email}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <ImportEmployeesModal />
      <Modal
        title="Export Employee Data"
        visible={isModalVisible}
        onOk={handleExport}
        onCancel={() => setIsModalVisible(false)}
        okText="Export"
        cancelText="Cancel"
      >
        <p>Are you sure you want to export the current employee data to Excel?</p>
      </Modal>
      <AllEmployeeAddPopup onEmployeeAdded={handleEmployeeAdded} />
    </div>
  );
};

export default AllEmployee;


